(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

  const main = document.getElementById('MainContent');
  if (!main) return;

  const observed = new WeakSet();
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('cf-motion-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08,
    }
  );

  const reveal = (element, delay = 0, isCard = false) => {
    if (!(element instanceof HTMLElement) || observed.has(element)) return;

    observed.add(element);
    element.classList.add('cf-motion-reveal');
    if (isCard) element.classList.add('cf-motion-card');
    if (delay > 0) element.style.setProperty('--cf-motion-delay', `${delay}ms`);
    observer.observe(element);
  };

  const register = (scope = main) => {
    const sections = scope === main
      ? Array.from(main.children).filter((element) => element.matches?.('.shopify-section'))
      : Array.from(scope.querySelectorAll('.shopify-section'));

    sections.forEach((section) => reveal(section));

    scope
      .querySelectorAll('.product-information__grid > .product-information__media, .product-information__grid > .product-details')
      .forEach((element, index) => reveal(element, index * 100));

    scope
      .querySelectorAll('.product-grid__item, .resource-list__item, .cf-home-product-card')
      .forEach((element, index) => reveal(element, (index % 4) * 90, true));
  };

  register();
  document.documentElement.classList.add('cf-motion-ready');

  const mutations = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        register(node);
      });
    });
  });

  mutations.observe(main, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => register(event.target));
})();
